import React from "react";
import { Link } from "react-router-dom";

const TeacherInfo = ({ name, image, professor }) => {
  return (
    <div>
      <div classNameName="">
        <div className="w-full  bg-white rounded-md pt-4 border border-gray-200 ounded-md shadow-[0px_4px_24px_0px_rgba(34,41,47,10%)]  text-gray-600 ">
          <div className="flex justify-end px-4 pt-4"></div>
          <div className="flex flex-col items-center pb-10">
            <img
              className="mb-4 w-24 h-24 rounded-full shadow-lg"
              src={image}
              alt="Bonnie image"
            />
            <h5 className="mb-1  font-medium text-sm text-gray-900 ">{name}</h5>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {professor}
            </span>
            <div className="flex mt-4 space-x-3 md:mt-6">
              <a
                href="#"
                className="inline-flex items-center py-2 px-4 text-sm font-medium text-center text-white bg-blue-700 rounded-md hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 "
              >
                <Link to="/chat">Message</Link>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="bg-white p-3 rounded-md shadow-[0px_4px_24px_0px_rgba(34,41,47,10%)] mt-4">
        <div class="flex space-x-6 items-center">
          <img src={image} class="w-auto h-24 rounded-lg" />
          <div>
            <p class="font-semibold text-base">{name}</p>
            <p class="font-semibold text-sm text-gray-400">{professor}</p>
          </div>
        </div>

        <div className="flex mt-4 space-x-3 md:mt-6 ">
          <a
            href="#"
            className="inline-flex items-center py-2 px-4 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            <Link to="/chat">Message</Link>
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default TeacherInfo;
